module.exports = __webpack_public_path__ + "img/99ec428791df4ad0987ff76c3378409c.png";